import axios from "axios";
import { getLeadSource } from "./lead";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = BASE ? `${BASE}/api` : null;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return e?.message || "Something went wrong. Please try again.";
};

// Returns {reference}. Throws on failure — never fake success.
export const submitEnquiry = async (kind, data, files = []) => {
  if (!API) throw new Error("Form service is not configured. Please email survey@geodrafting.com.");
  const fd = new FormData();
  fd.append("data", JSON.stringify(getLeadSource() ? { ...data, lead_source: getLeadSource() } : data));
  files.forEach((f) => fd.append("files", f));
  const res = await axios.post(`${API}/enquiries/${kind}`, fd, { timeout: 180000 });
  if (!res.data?.ok || !res.data?.reference) throw new Error("Submission could not be confirmed.");
  return res.data;
};
